import { z } from 'zod';

export const aggregationGranularitySchema = z.enum(['DAY', 'WEEK', 'MONTH', 'YEAR']);
export type AggregationGranularity = z.infer<typeof aggregationGranularitySchema>;

export const alertSeveritySchema = z.enum(['INFO', 'WARNING', 'CRITICAL']);
export type AlertSeverity = z.infer<typeof alertSeveritySchema>;

export const notificationChannelSchema = z.enum(['MNOTIFY', 'SMTP', 'WEBHOOK']);
export type NotificationChannel = z.infer<typeof notificationChannelSchema>;
